"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverageItems = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const token_input_1 = require("@pulse-web-ui/token-input");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const i18n_1 = require("../../i18n");
const insurance_period_type_1 = require("../../insurance-period.type");
const CoverageItems = ({ value, onChange, error, items, onAnalyticEventSend, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [allItems, setAllItems] = (0, react_1.useState)();
    const [suggestions, setSuggestions] = (0, react_1.useState)();
    const handleChange = (value) => {
        onChange(value);
        if (value.length) {
            onAnalyticEventSend &&
                onAnalyticEventSend(insurance_period_type_1.InsurancePeriodAnalyticEvent.ON_ITEMS_SELECT);
        }
    };
    const tokenInputValue = value;
    (0, react_1.useEffect)(() => {
        if (!items?.length)
            return;
        const newCList = [];
        const newSuggList = [];
        items.forEach((item) => {
            newCList.push({
                label: item.name,
                value: item.code,
            });
            if (!item.displayCategory)
                return;
            newSuggList.push({
                label: item.name,
                value: item.code,
                key: item.code,
            });
        });
        setAllItems(newCList);
        setSuggestions(newSuggList);
    }, [items]);
    return ((0, jsx_runtime_1.jsx)(token_input_1.TokenInput, { value: tokenInputValue, onChange: handleChange, options: allItems, suggestions: suggestions, label: t('SMART:InsurancePeriod.labels.coverageItems', {
            defaultValue: i18n_1.i18nDefaultValues.InsurancePeriod.labels.coverageItems,
        }), error: !!error, hintObject: {
            message: error?.message,
        } }));
};
exports.CoverageItems = CoverageItems;
